import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSuitcase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#suitcase_svg__a)">
      <path
        fill="#263E6A"
        d="M17.901 16.261c0-.207.16-.34.364-.34s.363.133.363.34c0 .2-.158.341-.363.341s-.364-.142-.364-.34m.097.982h.526v3.117h-.526zm.19 4.757c-2.045 0-3.708-1.653-3.708-3.684s1.663-3.685 3.708-3.685 3.707 1.653 3.707 3.685S20.232 22 18.188 22m0-6.701c-1.678 0-3.043 1.353-3.043 3.017s1.365 3.017 3.043 3.017c1.677 0 3.042-1.354 3.042-3.017 0-1.664-1.365-3.017-3.042-3.017M20.65 5.277H3.349C2.605 5.277 2 5.883 2 6.629v10.393c0 .746.605 1.353 1.35 1.353h9.815a.333.333 0 0 0 0-.667H7.01V5.944h9.983v7.39a.333.333 0 1 0 .666 0v-7.39h2.993c.377 0 .684.307.684.685v6.521a.333.333 0 1 0 .665 0V6.63c0-.747-.605-1.353-1.349-1.353M6.343 17.707H3.35a.685.685 0 0 1-.684-.684V6.629c0-.378.307-.685.684-.685h2.994zM8.45 4.576V2.834c0-.46.373-.834.831-.834h5.438c.459 0 .832.374.832.834v1.741a.333.333 0 1 1-.666 0V2.834a.17.17 0 0 0-.166-.167H9.28a.17.17 0 0 0-.166.167v1.741a.333.333 0 1 1-.665 0"
      />
    </g>
    <defs>
      <clipPath id="suitcase_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSuitcase;
